import {
  faInfoSquare,
  faCrown,
  faThList,
  faBars,
  faTimes,
  faBrowser,
  faCircleDot,
  faStar,
  faArrowLeftLong,
  faArrowRightLong,
  faHandPointUp
} from "@fortawesome/pro-regular-svg-icons";

export const iconspro = [
  faInfoSquare,
  faCrown,
  faThList,
  faBars,
  faTimes,
  faBrowser,
  faCircleDot,
  faStar,
  faArrowLeftLong,
  faArrowRightLong,
  faHandPointUp
];

import {
  faFacebookSquare,
  faInstagram,
  faTwitter,
  faGithub
} from "@fortawesome/free-brands-svg-icons";

export const iconsfree = [faFacebookSquare, faInstagram, faTwitter, faGithub];

import { } from "@fortawesome/pro-light-svg-icons";

export const iconslight = [];



// WEBPACK FOOTER //
// ./src/styles/fontawsome.js